import { Avatar, Flex, FlexProps, HStack, Text } from "@chakra-ui/react";
import { MouseEventHandler } from "react";

import { Nullable } from "foundation-ts/types";
import { $length } from "foundation-ts/commons";

import { $g1Color } from "@/theme/G1Style";
import { adminTitle, trueOrEmptyCard } from "@utils/functions";
import { G1Icon } from "@utils/icons";
import { useAuthContext } from "@hooks/useAuthContext";

export interface UserProfileProps extends FlexProps {
    logout: MouseEventHandler<SVGElement> ;
    adminPage?: boolean ;
}

export const UserProfile = (props: UserProfileProps) => {
    const { adminPage, logout } = props ;
    const { isAuthenticated, connectedUser } = useAuthContext();
//    const { data: userProfile, isError: profileError, isLoading: profileLoading } = useProfile(profileId, 'UserProfile') ;

    function _v(v: Nullable<string>, sepa?:Nullable<string>): string {
        return $length(v) === 0 ? '' : (v! + ($length(sepa) !== 0 ? sepa! : ''));
//        return profileError || !$length(v) ? '' : (profileLoading ? 'en chargement...' : v! + ($length(sepa)?sepa!:'')) ;
    }

    // optlog(`UserID: '${profileId}' loading: ${profileLoading} error: ${profileError}, profile: ${$ok(userProfile)?'OK':'<UNDEFINED>'}`) ;
    return trueOrEmptyCard(
        isAuthenticated, //!profileError,
        <HStack
            bg={$g1Color('sidebar.profile.bg')}
            color={$g1Color('sidebar.profile.write')}
            spacing="4"
            px="2"
            flexShrink={0}
            borderTopWidth="1px"
            p="4"
            cursor="pointer"
        >
            <Avatar size="sm" name={_v(connectedUser?.lastName)} src={_v(connectedUser?.avatarUrl)} color={$g1Color('sidebar.profile.avatar.write')} bg={$g1Color('sidebar.profile.avatar.bg')} />
            <Flex direction="column" fontWeight="medium" width="100%">
                <Text fontSize="15px">{_v(connectedUser?.firstName?.capitalize(), ' ')}{_v(connectedUser?.lastName?.toUpperCase())}</Text>
                <Text fontSize="12px" lineHeight="shorter" wordBreak="break-all">
                    {adminPage ? adminTitle(connectedUser?.userFlags?.profile) : _v(connectedUser?.email?.trim())}
                </Text>
            </Flex>
            <Flex>
                <G1Icon.Logout size="25px" onClick={logout} style={{ marginLeft: 'auto' }} color={$g1Color('sidebar.profile.icon')} />
            </Flex>
        </HStack>,
        false,
        !isAuthenticated, //profileError,
        "Impossible de récupérer le profil de l'utilisateur",
        "Connexion invalide",
    ) ;
} ;